// eslint-disable-next-line import/prefer-default-export
export const initializeReactMetadata = (stateParams, additionalParams) => {
  const { databaseId, context, resultName, hitSetKey, searchId, sort, order, uiDirectives } = stateParams;
  return { databaseId, context, resultName, hitSetKey, searchId, sort, order, uiDirectives, ...additionalParams };
};
